export default __webpack_public_path__ + "static/media/IconALNUS.9996ce5c.svg";